import DiscountTable from './Discount.gql';

export default DiscountTable;
